const STATS = [
  {
    value: "10L+",
    label: "Members and counting",
    bgDesktop: "/homepage/scd1.webp",
    bgMobile: "/homepage/scm1.webp",
  },
  {
    value: "30+",
    label: "New tools shared this week",
    bgDesktop: "/homepage/scd2.webp",
    bgMobile: "/homepage/scm2.webp",
  },
  {
    value: "160+",
    label: "Countries in the community",
    bgDesktop: "/homepage/scd3.webp",
    bgMobile: "/homepage/scm3.webp",
  },
  {
    value: "1,243",
    label: "Prompts shared this week",
    bgDesktop: "/homepage/scd4.webp",
    bgMobile: "/homepage/scm4.webp",
  },
] as const;

const GRID_SPAN = [
  "md:col-span-7",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-7",
] as const;

function StatCard({
  value,
  label,
  bgDesktop,
  bgMobile,
  className,
}: {
  value: string;
  label: string;
  bgDesktop: string;
  bgMobile: string;
  className?: string;
}) {
  return (
    <article
      className={`relative flex min-h-[140px] border border-white/20 w-full flex-col justify-center overflow-hidden rounded-2xl md:min-h-[190px] ${className ?? ""}`}
    >
      <picture className="pointer-events-none absolute inset-0">
        <source media="(min-width: 768px)" srcSet={bgDesktop} />
        <img
          src={bgMobile}
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
          decoding="async"
        />
      </picture>
      <div className="relative z-10 w-full px-6 py-6 text-left md:px-8 md:py-8">
        <p className=" font-semibold tracking-tight text-white text-[40px] md:text-[56px] md:leading-tight">
          {value}
        </p>
        <p className="mt-2 max-w-md text-sm font-normal leading-snug text-[#FFFFFFB8] md:text-base">
          {label}
        </p>
      </div>
    </article>
  );
}

export default function CommunityStats() {
  return (
    <section className="w-full bg-black py-8 sm:py-20 font-fira">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <header className="mb-10 md:mb-14">
          <div className="mx-auto w-full  text-left">
            <p className="mb-4 text-sm font-normal text-white uppercase tracking-[1.75px]">
              Inside the community
            </p>
            <h2 className="mb-4 max-w-4xl font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:text-[42px]">
             A million builders, in one room.
            </h2>
            <p className="max-w-2xl text-[14px] font-normal leading-relaxed text-[#FFFFFF85] md:text-[16px]">
              One curated space where builders swap what actually works - tools,
              prompts, and playbooks - before the rest of the internet catches on.
            </p>
          </div>
        </header>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-10">
          {STATS.map((stat, i) => (
            <StatCard
              key={stat.label}
              value={stat.value}
              label={stat.label}
              bgDesktop={stat.bgDesktop}
              bgMobile={stat.bgMobile}
              className={GRID_SPAN[i]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
